import { ApiMethod } from '@wajeez-web/stores/base';
import { AppWatch, appWatchClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { PaginatedRequest } from '@wajeez-web/core/api';

export const getPremiumCustomers: ApiMethod<
  PaginatedRequest,
  AppWatch.PaginatedResultOfGetPremiumClientsResponse,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_WajeezQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.wajeezQueries_premiumCustomers_V1(
      data.page,
      data.pageSize
    );
    if (response.success && response.data) {
      return response;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
